import React from 'react';
import Auxil from '../../hoc/Auxil/Auxil';

const blogPage = (props: any) => (
    <Auxil>
        <p>Under Construction</p>
    </Auxil>
);

export default blogPage;